export enum ROUTE_NAMES {
  HOME = "home",
  LOGIN = "login",
  RESET_PASSWORD = "reset-password",
  SIGNUP = "signup",
  GAME = "game",
  LOBBY = "lobby",
  START_GAME = "start-game",
  CREATE_DESK = "create-desk",
  RULES = "rules",
  PLAYERS = "players",
  STATISTICS = "statistics",
  TABLESTATS = "tablestats",
  GAMERESULT = "game-result",
  IMAGES = "images",
  DESK = "desk",
  WAIT_FOR_INVITES = "wait-for-invites",
  PROFILE_EDIT = "profile-edit",
}
